(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.FunkyCollectionOrder = api;
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var cached = Object.create(null);
  var sortSyncInstalled = false;
  var serverSorts = ['best-selling', 'manual', 'most-relevant'];
  var localSorts = ['price-ascending', 'price-descending', 'title-ascending', 'title-descending', 'created-ascending', 'created-descending'];

  function installSortSync(defaultSort) {
    if (typeof document === 'undefined' || sortSyncInstalled) return;
    sortSyncInstalled = true;
    function sync() {
      var select = document.getElementById('SortBy');
      var value = new URL(window.location.href).searchParams.get('sort_by') || defaultSort || 'manual';
      if (select && Array.prototype.some.call(select.options, function (option) { return option.value === value; })) select.value = value;
    }
    sync();
    // Browsers can restore old form values after pageshow/popstate. Update after
    // that restoration, without changing navigation or adding history entries.
    ['pageshow', 'popstate'].forEach(function (event) {
      window.addEventListener(event, function () { setTimeout(sync, 0); });
    });
  }

  function requestUrl(current, sort) {
    if (serverSorts.indexOf(sort) === -1) throw new Error('Unsupported collection sort: ' + sort);
    var url = new URL(current);
    url.searchParams.set('view', 'funky-order');
    url.searchParams.set('sort_by', sort);
    ['page', 'group', 'deck_group', 'mm_group', 'fk_size'].forEach(function (key) { url.searchParams.delete(key); });
    return url;
  }

  function readIds(url, fetcher) {
    var ids = [];
    var seen = Object.create(null);
    var expectedTotal;
    var expectedPages;
    function read(page) {
      var next = new URL(url);
      next.searchParams.set('page', page);
      return fetcher(next.href, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Order request failed');
        return response.json();
      }).then(function (data) {
        if (data.supported !== true || data.sort !== url.searchParams.get('sort_by')) {
          throw new Error('Server did not confirm requested collection sort');
        }
        if (!Array.isArray(data.ids) || data.ids.length > 250 || data.page !== page ||
            !Number.isInteger(data.pages) || data.pages < 0 || data.pages > 100 ||
            !Number.isInteger(data.total) || data.total < 0 || data.total > 25000) {
          throw new Error('Invalid order response');
        }
        if (page === 1) { expectedTotal = data.total; expectedPages = data.pages; }
        if (data.total !== expectedTotal || data.pages !== expectedPages) throw new Error('Collection changed while loading');
        data.ids.forEach(function (id) {
          if (!Number.isSafeInteger(id) || id <= 0 || seen[id]) throw new Error('Invalid or duplicate product ID');
          seen[id] = true;
          ids.push(String(id));
        });
        if (page < data.pages) return read(page + 1);
        if (ids.length !== expectedTotal) throw new Error('Incomplete collection order');
        return ids;
      });
    }
    return read(1);
  }

  function load(products, options) {
    options = options || {};
    installSortSync(options.defaultSort);
    var current = options.current || window.location.href;
    var sort = new URL(current).searchParams.get('sort_by') || options.defaultSort || 'manual';
    if (localSorts.indexOf(sort) !== -1) return Promise.resolve(products);
    if (serverSorts.indexOf(sort) === -1) return Promise.reject(new Error('Unsupported collection sort: ' + sort));
    var url = requestUrl(current, sort);
    var fetcher = options.fetch || window.fetch.bind(window);
    // Cache only within this page. Sizes do not require a new server order.
    if (!cached[url.href]) {
      cached[url.href] = readIds(url, fetcher).catch(function (error) {
        delete cached[url.href];
        throw error;
      });
    }
    return cached[url.href].then(function (ids) {
      var byId = Object.create(null);
      products.forEach(function (product) { byId[String(product.id)] = product; });
      return ids.map(function (id) {
        if (!byId[id]) throw new Error('Product catalog changed while loading');
        return byId[id];
      });
    });
  }

  function fail(error) {
    // Do not present an unverified order as "best selling" after a failed request.
    var wrapper = document.getElementById('size-filter-buttons');
    if (wrapper) {
      wrapper.textContent = '';
      var notice = document.createElement('span');
      notice.setAttribute('role', 'alert');
      notice.textContent = 'Tuotteiden lataus epäonnistui. ';
      var retry = document.createElement('a');
      retry.href = window.location.href;
      retry.textContent = 'Yritä uudelleen';
      wrapper.appendChild(notice);
      wrapper.appendChild(retry);
    }
    console.error('Collection loading failed:', error);
  }

  return { load: load, fail: fail, requestUrl: requestUrl };
}));
